import { Injectable, Signal, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';

import { LDFeatureFlags } from '@frontend/sports/launch-darkly/feature';
import { LaunchDarklyService } from '@frontend/vanilla/features/launch-darkly';
import { map } from 'rxjs';

import { BannerGamesDisplayType } from './model';

@Injectable({ providedIn: 'root' })
export class UpSellCrossSellLDService {
    private readonly launchDarklyService = inject(LaunchDarklyService);
    readonly eSoccerOnAZMenuEnabled: Signal<boolean>;
    readonly bannerGamesDisplayType: Signal<string>;

    constructor() {
        this.eSoccerOnAZMenuEnabled = toSignal(
            this.launchDarklyService.getFeatureFlagValue$(LDFeatureFlags.ESoccerInAZMenu, false).pipe(map((value) => !!value)),
            { initialValue: false },
        );

        this.bannerGamesDisplayType = toSignal(
            this.launchDarklyService.getFeatureFlagValue$(LDFeatureFlags.BannerGamesDisplayType, BannerGamesDisplayType.SingleRow),
            { initialValue: BannerGamesDisplayType.SingleRow },
        );
    }
}
